var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$s.ActionBarWrapper},[_c('atomic-action-bar',_vm._g(_vm._b({},'atomic-action-bar',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }